<div layout class="justify-content-space-between flex-wrap">

  <div layout class="flex-column">
    <p class="dark-text m-b-sm" translate>LEAD_GENERATION.SETTINGS.DAYS_WEEK</p>
    <cc-lg-days-range
      [selectedDays]="days"
      [disabledDays]="disabledDays"
      [isNotValid]="this.range.hasError('noDays')"
      (selectedDay)="onSelectionChanged($event)"
    ></cc-lg-days-range>
  </div>

  <div layout>
    <div layout class="flex-column m-b-sm hours-wrapper">
      <div class="hour-label-wrapper">
        <p class="dark-text m-b-sm" translate>LEAD_GENERATION.SETTINGS.HOURS</p>
        <div layout class="h-100-p align-item-start m-t-sm"
             [style.visibility]="deleteEnabled ? 'visible' : 'hidden'">
          <div layout
               (click)="deleteRange()"
               class="align-item-center dark-grey-text dark-red-text-hover pointer delete-hours-range">
            <img src="/assets/img/channels/trash.png" alt="">
          </div>
        </div>
      </div>

      <div layout class="justify-content-space-between dark-text">
        <form [formGroup]="range">


          <div layout
               *ngFor="let hour of hoursFormControls; let i = index, let isLast = last"
               class="form lg-down-flex-wrap align-item-center m-b-sm">
            <span class="timepicker-label" translate>FROM</span>
            <cc-timepicker
              ngDefaultControl
              [hoursFormControl]="hour.get('from')"
              placeholder="08:00 AM"
              [class]="{'invalid': hour.hasError('invalidTime'), 'hours-input': true, 'correct-border': true}"
            ></cc-timepicker>
            <span class="timepicker-label to" translate>TO</span>
            <cc-timepicker
              ngDefaultControl
              [hoursFormControl]="hour.get('to')"
              placeholder="04:00 PM"
              [class]="{'invalid': hour.hasError('invalidTime'), 'hours-input': true, 'correct-border': true}"
            ></cc-timepicker>

            <i
              [style.visibility]="canRemoveHoursRange ? 'visible' : 'hidden'"
              (click)="removeHoursRange(i)"
              class="material-icons pointer dark-red-hover circle remove-action-icon">
              remove_circle_outline
            </i>

            <i
              *ngIf="isLast"
              (click)="addHoursRange()"
              class="material-icons pointer green-text primary-hover circle add-action-icon">
              add_circle_outline
            </i>

          </div>

        </form>
      </div>
    </div>
  </div>

</div>
